import { createScriptIn } from './ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from './UIUtilsEjsVariables.ts';
import { ClientUserState } from './ClientUserState.ts';
export class AdinPlayLoader {
    static init() {
        var _ClientUserState_userState;
        if (this.initialized) return;
        if (window.location.hostname === 'localhost') return;
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        if (UIUtilsEjsVariables.isUserOnMobile && UIUtilsEjsVariables.shouldHideAdsOnMobile) return;
        if (UIUtilsEjsVariables.showVliAdAtBottomInGame) return;
        if (ClientUserState.isStale()) return;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds()) return;
        createScriptIn(document.body, '//api.adinplay.com/libs/aiptag/pub/KTN/colonist.io/tag.min.js');
        this.initialized = true;
    }
}
AdinPlayLoader.initialized = false;
